export default function ChevronRight(props) {
    const fill = props.fill ?? 'var(--color-blue)';
    const stroke = props.stroke ?? 'var(--color-blue)';
    return (
        <svg
            width="28"
            height="28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="14.49" cy="13.538" r="13" stroke={stroke} />
            <path
                fill={fill}
                d="M17.53 12.123l1.413 1.415-5.656 5.657-1.415-1.415z"
            />
            <path
                fill={fill}
                d="M11.871 9.295l1.414-1.414 5.657 5.657-1.414 1.414z"
            />
        </svg>
    );
}
